'use client';

import React from 'react';
import Link from 'next/link';
import { useAOS } from '../../../../lib/hooks/useAOS';
import styles from './HeroSection.module.scss';

type HeroSectionProps = {
  data: {
    bgImage: string;
    title: string;
    logoUrl?: string;
    companyName?: string;
    subtitle: string;
    cta: string;
    ctaLink: string;
    mask?: boolean;
  };
};

export const HeroSection: React.FC<HeroSectionProps> = ({ data }) => {
  const { bgImage, logoUrl, companyName, title, subtitle, cta, ctaLink, mask = true } = data;
  useAOS();

  return (
    <section
      className={styles.heroSection}
      style={{ backgroundImage: `url(${bgImage})` }}
    >
      <div className={mask ? styles.heroOverlay : styles.heroOverlayNoMask}>
        {(data.logoUrl || data.companyName) && (
          <div className={styles.heroBranding} data-aos="fade-down" data-aos-delay="100">
            {data.logoUrl && (
              <img
                src={data.logoUrl}
                alt={data.companyName || "Logo"}
                className={styles.heroLogo}
              />
            )}
            {data.companyName && (
              <span className={styles.companyName}>{data.companyName}</span>
            )}
          </div>
        )}
        <h1 className={styles.heroTitle} data-aos="fade-down">
          {title}
        </h1>
        <p className={styles.heroSubtitle} data-aos="fade-up">
          {subtitle}
        </p>
        <Link
          href={ctaLink}
          className={mask ? styles.heroButton : styles.heroButtonNoMask}
          data-aos="zoom-in"
        >
          {cta}
        </Link>
      </div>
    </section>
  );
};
